import {
  RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE,
  ARRIVAL_MAILBOX_CHECKED,
  ARRIVAL_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_ARRIVAL_MAILBOXES,
  DESELECT_ALL_ARRIVAL_MAILBOXES,
} from './types/ArrivalPostalOperatorActionTypes';

export function retrieveInboundPostalOperatorsMailboxRequestActionCreator(
  payload,
  reportDefinition,
  arrivalCheckedMailboxes,
) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST,
    payload,
    reportDefinition,
    arrivalCheckedMailboxes,
  };
}

export function retrieveInboundPostalOperatorsMailboxSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS,
    payload,
  };
}

export function retrieveInboundPostalOperatorsMailboxFailureActionCreator(error) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE,
    error,
  };
}

export function arrivalMailboxCheckedActionCreator(
  checkedMailboxes,
  reportDefinition,
) {
  return {
    type: ARRIVAL_MAILBOX_CHECKED,
    checkedMailboxes,
    reportDefinition,
  };
}

export function onArrivalPostalOperatorExpanded(expandedPostalOperators) {
  return {
    type: ARRIVAL_POSTAL_OPERATOR_EXPANDED,
    expandedPostalOperators,
  };
}

export function onSelectAllArrivalMailboxes(nodes) {
  return {
    type: SELECT_ALL_ARRIVAL_MAILBOXES,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllArrivalMailboxes() {
  return {
    type: DESELECT_ALL_ARRIVAL_MAILBOXES,
  };
}
